import { InjectionToken } from '@angular/core';

export const NGX_USERSNAP_CONFIG = new InjectionToken<ConfigOption>('NGX_USERSNAP_CONFIG');
export interface ConfigOption {
  apiUrl?: string;
  apiKey?: string;
}
